import React, { useEffect, useState } from 'react'
import MasterLayout from '../../masterLayout/MasterLayout'
import axios from 'axios'
import { BaseUrl, ImageUrl } from '../../helper/apiHelper'
import { Icon } from '@iconify/react/dist/iconify.js'
// import { toast } from 'react-toastify'
import toast from 'react-hot-toast'

const ClientLogo = () => {
  console.log(process.env.REACT_APP_IMAGE_BASE_URL);
  const [clientLogos, setClientLogos] = useState([])
  const [sponsorLogo, setSponsorLogo] = useState(false)
  const [isLoading, setIsLoading] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const getClientLogos = async () => {
    try {
      let response = await axios.get(
        `${BaseUrl}/get-sponsors-logo-admin`
      );
      console.log(response.data.data);
      setClientLogos(response.data.data)
    } catch (error) {
      console.log(error);

    }
  }
  useEffect(() => {
    getClientLogos()
  }, [])

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedImage(file);
    }
  };

  const handleImageRemove = () => {
    setSelectedImage(null);
  };
  const handleAddSponsorLogo = async () => {
    if (!selectedImage) {
      toast.error("Please upload an image");
      return;
    }

    const formData = new FormData();
    formData.append("logo_img", selectedImage);

    try {
      setIsLoading(true);

      const response = await axios.post(`${BaseUrl}/add-sponsor-logo`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      toast.success("Sponsor logo added successfully");
      setSponsorLogo(false); // Close modal
      setSelectedImage(null); // Reset image
      getClientLogos(); // Refresh the logo list
    } catch (error) {



      if (error?.code === "ERR_NETWORK") {
        toast.error("File size is too large. Please upload a smaller file.");

      } else {
        toast.error(error?.response?.data?.message || "Failed to add sponsor logo");
      }

    } finally {
      setIsLoading(false);
    }
  };

  console.log("", clientLogos);


  const handleProductDelete = async (logoId) => {
    const toastId = toast.loading("Deleting Sponsor Logo...");

    try {
      let response = await axios.delete(`${BaseUrl}/delete-sponsor-logo/${logoId}`);

      console.log(response);

      if (response.status === 200) {
        toast.success(response.data.message || "Deleted successfully", { id: toastId });
        getClientLogos();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong", { id: toastId });
      console.log(error?.response?.data?.message);
    }
  };

  return (
    <>
      <MasterLayout>
        <div className="card h-100 p-0 radius-12 overflow-hidden gallery-scale">
          <div className="card-body p-24">
            <div className="d-flex justify-content-between align-items-center" style={{ marginBottom: "10px" }}>
              <h6 htmlFor="" className="text-muted" >Sponsor Logos</h6>
              <button
                type="button"
                onClick={() => setSponsorLogo(!sponsorLogo)}

                className="btn btn-primary-600 radius-8 px-20 py-11"
              >
                + Add Sponsor Logos
              </button>
            </div>

            <div className="row gy-4">

              {clientLogos.map((items, index) => {
                console.log(items.logo_url);

                return (
                  <div className="col-xxl-3 col-md-4 col-sm-6" key={index}>
                   <div
  className="hover-scale-img border radius-16 overflow-hidden p-8"
  style={{ position: "relative", backgroundColor: "#f5f5f5" }} // light gray
>

                      <a
                        // href="assets/images/gallery/gallery-img1.png"
                        href="#"
                        className="popup-img w-100  d-flex radius-12 overflow-hidden"
                        style={{height:"180px"}}
                      >
                        <img
                          src={`${ImageUrl}/${items.logo_url.replace(/^\/+/, '')}`}
                          alt="sponsors logo"
                          className="hover-scale-img__img w-100 h-100 object-fit-contain"
                        />
                      </a>


                      <button
                        type="button"
                        className="fw-medium rounded-circle w-40-px h-40-px d-flex justify-content-center align-items-center border-0"
                        title="Delete"
                        style={{
                          backgroundColor: "rgba(38, 47, 77, 0.08)", // soft version of --primary-600
                          color: "#262F4D", // matches primary
                          border: "1px solid #262F4D",
                          position: "absolute",
                          top: "7px",
                          right: "7px"
                        }}
                        onClick={() => handleProductDelete(items?.id)}


                      >
                        <Icon icon="mdi:trash-can-outline" className="icon text-lg" />
                      </button>
                    </div>
                  </div>
                );
              })}



            </div>
          </div>
        </div>


        {sponsorLogo &&

          <div className="modal fade show" style={{ display: "block" }}>
            <div
              className="modal-dialog modal-lg modal-dialog-centered"
              style={{ zIndex: 11122 }}
            >
              <div className="modal-content radius-16 bg-base">
                <div className="modal-header py-16 px-24 border border-top-0 border-start-0 border-end-0">
                  <h1 className="modal-title fs-5">Add Sponsor Logo</h1>
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={() => setSponsorLogo(!sponsorLogo)}
                  />
                </div>

                <div className="modal-body p-24">
                  <form>
                    <div className="row">



                      <div className="card-body p-0">

                        <div className="upload-image-wrapper d-flex align-items-center gap-3 flex-wrap">
                          <div className="uploaded-imgs-container d-flex gap-3 flex-wrap">
                            {selectedImage && (
                              <div className="position-relative h-120-px w-120-px border input-form-light radius-8 overflow-hidden border-dashed bg-neutral-50">
                                <button
                                  type="button"
                                  className="uploaded-img__remove position-absolute top-0 end-0 z-1 text-2xxl line-height-1 me-8 mt-8 d-flex"
                                  onClick={handleImageRemove}
                                >
                                  <Icon icon="radix-icons:cross-2" className="text-xl text-danger-600" />
                                </button>
                                <img
                                  className="w-100 h-100 object-fit-cover"
                                  src={URL.createObjectURL(selectedImage)}
                                  alt="Uploaded Preview"
                                />
                              </div>
                            )}
                          </div>



                          <label
                            className={`upload-file-multiple h-120-px w-120-px border input-form-light radius-8 overflow-hidden border-dashed bg-neutral-50 bg-hover-neutral-200 d-flex align-items-center flex-column justify-content-center gap-1 ${selectedImage ? "d-none" : ""}`}
                            htmlFor="upload-category"
                          >
                            <Icon icon="solar:camera-outline" className="text-xl text-secondary-light" />
                            <span className="fw-semibold text-secondary-light">Upload</span>
                            <input
                              id="upload-category"
                              type="file"
                              hidden
                              accept="image/*"
                              onChange={handleImageChange}
                            />
                          </label>
                        </div>
                      </div>

                      <div className="d-flex align-items-center justify-content-center gap-3 mt-24">
                        <button
                          type="button"
                          className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-40 py-11 radius-8"
                          onClick={() => setSponsorLogo(!sponsorLogo)}
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary border border-primary-600 text-md px-48 py-12 radius-8 d-flex align-items-center justify-center gap-2"
                          onClick={handleAddSponsorLogo}
                          disabled={isLoading}
                        >
                          {isLoading ? (
                            <>
                              <span className="spinner-border spinner-border-sm" role="status" />
                              Saving...
                            </>
                          ) : (
                            "Save"
                          )}
                        </button>

                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            {/* Optional backdrop */}
            <div
              className="modal-backdrop fade show"
              //   onClick={handleCloseModal}
              style={{ zIndex: 1040 }}
            />
          </div>
        }

      </MasterLayout>
    </>
  );
}

export default ClientLogo